import Backbone from 'backbone';

var MAX_PASSWD_LENGTH = 4;
var SERVICE_TYPE = 'PASSWD';

export var PasswdModel = Backbone.Model.extend({
  url: 'mfa/authenticate',

  defaults: function () {
    return {
      resultCode: null,
      resultText: '',
      isSuccess: false,
      inputValue: '',
      displayValue: '',
      isReady: false
    };
  },

  initialize: function () {},

  parse: function (res) {
    return res.result;
  },

  add: function (input) {
    var val = this.get('inputValue');
    var display = this.get('displayValue');

    this.set({
      inputValue: val + input,
      displayValue: display + '*'
    });

    if (this.get('inputValue').length >= MAX_PASSWD_LENGTH) {
      this.set({
        isReady: true
      });
    }
  },

  reset: function () {
    this.set(this.defaults());
  },

  authenticate: function () {
    this.save({
      type: SERVICE_TYPE,
      code: this.get('inputValue')
    });
  }
});
